import ModalPopup from '@aon/aon-tws-common-ui/build/lib/components/Modal/Modal';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { WarningModalBody, WarningModalHeadline } from './styles/globalStyles';

const NormalWrappingDiv = styled.div`
	white-space: normal;
`;
NormalWrappingDiv.displayName = 'NormalWrappingDiv';

export interface IWarningProps {
	isOpen: boolean;
	contentHeadline: string | JSX.Element;
	contentBody: string | JSX.Element;
	secondaryButtonText?: string;
	primaryButtonDisabled?: boolean;
	onClose(): void;
	onSubmit?(): void;
}

export class WarningModal extends React.Component<IWarningProps> {
	public render() {
		const { primaryButtonDisabled, secondaryButtonText } = this.props;

		return (
			<ModalPopup
				isOpen={this.props.isOpen}
				title={ContentConstants.WARNING_MODAL_TITLE}
				primaryButtonText={ContentConstants.BUTTONS_CONTINUE}
				primaryButtonDisabled={primaryButtonDisabled}
				secondaryButtonText={secondaryButtonText || ContentConstants.BUTTONS_CANCEL}
				contenthcentered={true}
				contentvcentered={true}
				contentfullwidth={false}
				onClosed={this.props.onClose}
				onSubmit={this.props.onSubmit}
				type={'lightbox'}
				headericon='warning'
				headericoncolor='#ff0000'
			>
				<NormalWrappingDiv>
					<WarningModalHeadline>{this.props.contentHeadline}</WarningModalHeadline>
					<WarningModalBody>{this.props.contentBody}</WarningModalBody>
				</NormalWrappingDiv>
			</ModalPopup>
		);
	}
}
